export const boilerBrands = [
  {
    id: "ariston",
    name: "Ariston",
    image:
      "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "101", issue: "Overheat", meaning: "ქვაბი გადახურდა. შეამოწმე ცირკულაცია და ტუმბო." },
      { code: "108", issue: "Low Pressure", meaning: "სისტემაში დაბალი წნევაა. შეავსე სისტემა 1.2-1.5 bar-მდე." },
      { code: "501", issue: "Ignition Failure", meaning: "ალმა არ ინთება. საჭიროა გაზის მიწოდებისა და ელექტროდის შემოწმება." },
      { code: "607", issue: "Fan Fault", meaning: "ვენტილატორის ან წვის ჰაერის არხის პრობლემა." },
    ],
  },
  {
    id: "baxi",
    name: "Baxi",
    image:
      "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "E01", issue: "No Flame", meaning: "ცეცხლი არ ფიქსირდება. შეამოწმე გაზი და ანთების კვანძი." },
      { code: "E10", issue: "Low Water Pressure", meaning: "წყლის წნევა დაბალია. შეავსე სისტემა." },
      { code: "E25", issue: "Overheat", meaning: "გადახურების დაცვა ჩაირთო. სითბოს გადაცემა ან ტუმბო შეამოწმე." },
      { code: "E35", issue: "Flame Signal Error", meaning: "არასწორი ალმის სიგნალი. საჭიროა სენსორის დიაგნოსტიკა." },
    ],
  },
  {
    id: "ferroli",
    name: "Ferroli",
    image:
      "https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "A01", issue: "Ignition Lockout", meaning: "ანთება ვერ ხერხდება. გაზის წნევა/იონიზაციის ელექტროდი შეამოწმე." },
      { code: "F05", issue: "Air Pressure Switch", meaning: "კვამლის/ჰაერის კონტროლის სენსორის შეცდომა." },
      { code: "F37", issue: "Low Pressure", meaning: "სისტემის წნევა არასაკმარისია." },
      { code: "F40", issue: "High Pressure", meaning: "წნევა ზედმეტად მაღალია. საჭირო არის სისტემის განტვირთვა." },
    ],
  },
  {
    id: "vaillant",
    name: "Vaillant",
    image:
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "F.22", issue: "Low Water Pressure", meaning: "წყლის უკმარისობა/დაბალი წნევა." },
      { code: "F.28", issue: "Ignition Failure", meaning: "ქვაბი ვერ ინთება. გაზის სარქველი და ელექტროდი გადაამოწმე." },
      { code: "F.29", issue: "Flame Loss", meaning: "ალმა ჩაიქრა მუშაობისას." },
      { code: "F.75", issue: "Pump/Pressure Sensor", meaning: "ტუმბო ან წნევის სენსორი არ რეაგირებს სწორად." },
    ],
  },
  {
    id: "bosch",
    name: "Bosch / Junkers",
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "EA", issue: "Flame Not Detected", meaning: "ალმა არ ფიქსირდება. გაზის მიწოდება გადაამოწმე." },
      { code: "C6", issue: "Fan Fault", meaning: "ვენტილატორის ან გამონაბოლქვის არხის ხარვეზი." },
      { code: "A7", issue: "DHW Sensor Fault", meaning: "ცხელი წყლის სენსორის პრობლემა." },
      { code: "E9", issue: "Overheat Safety", meaning: "გადახურების დაცვა აქტიურდა." },
    ],
  },
  {
    id: "immergas",
    name: "Immergas",
    image:
      "https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "01", issue: "Ignition Block", meaning: "ანთება ბლოკირებულია. გაზი/ელექტროდი შეამოწმე." },
      { code: "02", issue: "Safety Thermostat", meaning: "უსაფრთხოების თერმოსტატი ჩაერთო გადახურების გამო." },
      { code: "10", issue: "Low Pressure", meaning: "სისტემაში წნევა დაბალია." },
      { code: "27", issue: "Insufficient Circulation", meaning: "ცირკულაცია არასაკმარისია. ტუმბო/ფილტრი შეამოწმე." },
    ],
  },
  {
    id: "viessmann",
    name: "Viessmann",
    image:
      "https://images.unsplash.com/photo-1560185008-a33f7f1302f8?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "F2", issue: "Burner Fault", meaning: "წვის კვანძის შეცდომა ან ანთების პრობლემა." },
      { code: "F4", issue: "Flame Signal Missing", meaning: "იონიზაციის სიგნალი არ არის." },
      { code: "F5", issue: "Fan/Flue Issue", meaning: "ჰაერის წნევის ან ვენტილატორის ხარვეზი." },
      { code: "A9", issue: "DHW Sensor", meaning: "ცხელი წყლის სენსორის გაუმართაობა." },
    ],
  },
  {
    id: "navien",
    name: "Navien",
    image:
      "https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=900&q=80",
    codes: [
      { code: "E003", issue: "Ignition Failure", meaning: "ანთება ვერ მოხდა. გაზის მიწოდება და ელექტროდი გადაამოწმე." },
      { code: "E012", issue: "Flame Loss", meaning: "ალმა დაიკარგა მუშაობისას." },
      { code: "E110", issue: "Air Pressure Error", meaning: "გამონაბოლქვის/ჰაერის არხის ბლოკი ან ვენტილატორის პრობლემა." },
      { code: "E302", issue: "Low Water Pressure", meaning: "წყლის წნევა ნაკლებია დასაშვებზე." },
    ],
  },
];
